module.exports = __webpack_public_path__ + "img/cdu-logo.279a013e.png";